import { useMutation } from "@apollo/client";

import { GqlObservationStatus } from "~/__generated__";

import { MapEditorObservationPanel_ObservationChangeStatusDocument } from "./mutations.generated";

export function useChangeObservationStatusMutation() {
    const [mutate, result] = useMutation(MapEditorObservationPanel_ObservationChangeStatusDocument);

    const changeStatus = (observationId: string, status: GqlObservationStatus) => {
        return mutate({
            variables: {
                input: {
                    observationId,
                    status,
                },
            },
        });
    };

    return [changeStatus, result] as const;
}
